import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b3d388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Từ tháng", -1))
const _hoisted_4 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đến tháng", -1))
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Chọn thời gian thống kê báo cáo sự cố y khoa" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Calendar, {
              id: "monthSelect",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
              view: "month",
              dateFormat: "mm/yy",
              yearRange: "2000:2100",
              showButtonBar: false,
              showIcon: true,
              manualInput: false,
              onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Calendar, {
              id: "monthSelect2",
              modelValue: $setup.date2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.date2) = $event)),
              view: "month",
              dateFormat: "mm/yy",
              yearRange: "2000:2100",
              showButtonBar: false,
              showIcon: true,
              manualInput: false,
              onDateSelect: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectCalendar()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Dialog, {
        header: "Biểu đồ thống kê báo cáo sự cố y khoa",
        visible: $setup.showStatistical,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showStatistical) = $event)),
        style: {"width":"70em"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Chart, {
            type: "bar",
            data: $setup.totalData,
            options: _ctx.basicOptions
          }, null, 8, ["data", "options"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}